export default __webpack_public_path__ + "static/contact1-a0017bbd9ad58c35b74865a30974af27.webp";